import {BrowserRouter, Route, Routes} from "react-router-dom"
import {Layout} from "./components/common/Layout"
import {Home} from "./pages/Home"
import {BlogSinglePage} from "./components/common/BlogSinglePage"
import {About} from "./pages/About"
import {Courses} from "./pages/Courses"
import {Talents} from "./pages/Talents"
import {Instructor} from "./pages/Instructor"
import Notes from "./pages/Notes";
import Social from "./pages/Social";
import Login from "./pages/Login";
import YouTubeVideos from "./pages/YouTubeVideos";
import TecherProfile from "./pages/TecherProfile";
import Class from "./pages/Class";
import { AuthProvider } from './context/AuthContext';
import Shop from "./pages/Shop"
import NewsPage from "./pages/NewsPage"
import ArticleCard from "./components/common/ArticleCard"
import OLPastPapers from "./pages/OLPastPapers"
import ALPastPapers from "./pages/ALPastPapers"
import OLFolderPage from "./pages/OLFolderPage"
import ALFolderPage from "./pages/ALFolderPage"
import JobList from "./pages/JobList"
import RoomBooking from "./pages/RoomBooking"



function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route
                        path='/'
                        element={
                            <Layout>
                                <Home/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/about'
                        element={
                            <Layout>
                                <About/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/courses'
                        element={
                            <Layout>
                                <Courses/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/instructor'
                        element={
                            <Layout>
                                <Instructor/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/talent'
                        element={
                            <Layout>
                                <Talents/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/single-blog'
                        element={
                            <Layout>
                                <BlogSinglePage/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/notes'
                        element={
                            <Layout>
                                <Notes/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/social'
                        element={
                            <Layout>
                                <Social/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/login'
                        element={
                            <Layout>
                                <Login/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/booking'
                        element={
                            <Layout>
                                <RoomBooking/>
                            </Layout>
                        }
                    />
                    <Route
                        path='/youtube'
                        element={
                            <Layout>
                                <YouTubeVideos />
                            </Layout>
                        }
                    />
                    <Route
                        path='/profile'
                        element={
                            <Layout>
                                <TecherProfile />
                            </Layout>
                        }
                    />
                    <Route
                        path='/class'
                        element={
                            <Layout>
                                <Class />
                            </Layout>
                        }
                    />
                    <Route
                        path='/shop'
                        element={
                            <Layout>
                                <Shop />
                            </Layout>
                        }
                    />
                    <Route
                        path='/news/:id'
                        element={
                            <Layout>
                                <NewsPage />
                            </Layout>
                        }
                    />
                    <Route
                        path='/article'
                        element={
                            <Layout>
                                <ArticleCard />
                            </Layout>
                        }
                    />
                    <Route
                        path='/ol/:folderId'
                        element={
                            <Layout>
                                <OLPastPapers />
                            </Layout>
                        }
                    />
                    <Route
                        path='/al/:folderId'
                        element={
                            <Layout>
                                <ALPastPapers />
                            </Layout>
                        }
                    />
                    <Route
                        path='/ol-folder'
                        element={
                            <Layout>
                                <OLFolderPage />
                            </Layout>
                        }
                    />
                    <Route
                        path='/al-folder'
                        element={
                            <Layout>
                                <ALFolderPage />
                            </Layout>
                        }
                    />
                    <Route
                        path='/jobs'
                        element={
                            <Layout>
                                <JobList />
                            </Layout>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    )
}

export default App
